module.exports = __webpack_public_path__ + "img/logo.e202868c.svg";